var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"uploader",attrs:{"action":"#","http-request":_vm.uploadAttach,"multiple":"","before-upload":_vm.beforeUpload,"show-file-list":false}},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-upload2"}},[_vm._v("上传附件")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }